import { useMemo } from 'react';
import { CognitoUser } from '@aslanpay/portal-common-lib';

/* Determines whether the currently authenticated user signed in via SSO */
const useIsSSOUser = (cognitoUser?: CognitoUser): boolean => {
  return useMemo(() => {
    // For federated (SSO) users, attributes is undefined and identity
    // info is in the ID token payload's identities claim
    const identities = cognitoUser?.signInUserSession?.idToken?.payload?.identities;

    return Array.isArray(identities) && identities.length > 0;
  }, [cognitoUser]);
};

export default useIsSSOUser;
